"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEAVE_IAB_MODAL_ID = void 0;
exports.LEAVE_IAB_MODAL_ID = 'qubic-connect-leave-iab-modal';
